import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import DataTable from '../../components/Table/DataTable';
import SearchBox from './../../components/SearchBox/SearchBox';

import { showAlert } from '../../store/ducks/alert';
import { getWebhookActions, getWebhookActionsBySearch } from '../../services/webhook';
import { CircularProgress } from '@material-ui/core';
import { Launch } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';

const WebhookActions = ({ location, match }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [webhooks, setWebhooks] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });

  const [open, setOpen] = useState(false);
  const [tagId, setTagId] = useState();
  const [slug, setSlug] = useState();

  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  useEffect(() => {
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displaywebhooks();
  }, [isSearching, page]);

  useEffect(() => {
    document.addEventListener('keydown', escape, false);

    return () => {
      document.removeEventListener('keydown', escape, false);
    };
  }, []);

  const escape = useCallback(event => {
    if (event.keyCode === 27) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
      window.history.pushState({ searching: true }, 'Searching', '/' + window.location.href.split('/')[3]);
    }
  }, []);

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const headers = ['uniqueId', 'source', 'createdAt'];

  const customActions = [
    {
      icon: <Launch />,
      action: item => {
        history.push(`/webhooks/${item.uniqueId}`);
      },
    },
  ];

  const displaywebhooks = async () => {
    try {
      setIsLoading(true);
      let webhooks;
      if (isSearching) {
        const { data } = await getWebhookActionsBySearch(searchField.searchItem, searchField.search);
        webhooks = data;
      } else if (!isSearching && Object.keys(match.params).length === 0) {
        const { data } = await getWebhookActions(page);
        webhooks = data;
      }
      if (!webhooks) return;

      setWebhooks(webhooks.rows);
      setTotalItems(webhooks.count);
      setTotalPages(webhooks.pages);
      setPage(webhooks.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>Webhooks ({totalItems})</h1>

        <SearchBox selectItems={['source', 'uniqueId']} onSubmitSearch={handleSubmitSearch} isSearching={isSearching} onKeyDown={escape} />
      </div>

      <DataTable
        useUid={false}
        head={headers}
        body={webhooks}
        action={true}
        isSlug
        customActions={customActions}
        bodyColumn={headers}
        linkPath={'webhooks'}
        totalPages={totalPages}
        currentPage={page}
        setPageChange={setPage}
      />
    </>
  );
};

export default WebhookActions;
